export default "__VITE_ASSET__DMHDPQN___"